import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 15px;
  height: 310px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    height: 400px;
  }
`;

export const Title = styled(Typography.Title)`
  font-size: 18px;
`;

export const SubTitle = styled(Typography.Body)`
  color: ${({ theme }) => theme.palette.secondary.labels};
  text-align: center;
`;
